// extracted by mini-css-extract-plugin
module.exports = {"item":"_35a1d4a6","link":"_8aef1213","image":"_e46e97b4","shimmerLoadingBackground":"_3315ce9e"};